<div class="container" *ngIf="data">
    <div class="row">
        <div class="image-container col-12 col-lg-6 offset-md-0 offset-lg-0"
             [ngClass]="{
                'col-md-8 offset-md-2': !data.useFullImage,
                'col-md-12 no-packshot': data.useFullImage
             }">
            @if (!data.useFullImage) {
                <div class="image-backdrop" [ngStyle]="theme ? { backgroundColor: '#' + theme } : null"></div>
                <div class="image" appParallaxElement [travel]="100" [dullness]="25">
                    <app-image
                        [image]="data.image"
                        [width]="600"
                        [height]="600"
                        crop="min"
                        format="none"
                        [index]="data.spotIndex"
                    ></app-image>
                    <ng-container *ngIf="data.imageLink || mainProduct">
                        <a *ngIf="mainProduct; else imageLink" [routerLink]="mainProduct.productUrl"
                           class="kk-link-cover"
                        ><span class="kk-visuallyhidden">{{ mainProduct.productName }}</span></a
                        >
                        <ng-template #imageLink>
                            <a [routerLink]="data.imageLink.url" class="kk-link-cover"
                            ><span class="kk-visuallyhidden">{{ data.imageLink.name }}</span></a
                            >
                        </ng-template>
                    </ng-container>
                </div>
            } @else {
                <div class="image no-padding">
                    <app-image
                        [image]="data.image"
                        [width]="600"
                        [height]="600"
                        [index]="data.spotIndex"
                        crop="crop"
                        [style]="{
                            objectFit: 'cover',
                            objectPosition: 'center'
                        }"
                    ></app-image>
                </div>
            }
        </div>
        <div class="col-12 col-lg-6 offset-lg-6"
             [ngClass]="{
                'col-md-12 no-vertical-space no-packshot-content': data.useFullImage
             }">
            <app-spot-headline *ngIf="data.headlineText as headlineText" [index]="data.spotIndex">
                {{ headlineText }}
            </app-spot-headline>
            <div class="kk-rte" appInterceptLinks [innerHTML]="data.richText | safe: 'html'"></div>

            <div class="link" *ngIf="data.link as link">
                <app-arrow-link *ngIf="data.link as link" [link]="link" [arrowFirst]="true">
                    {{ link.name }}
                </app-arrow-link>
            </div>

            @if (slider.hasPaging) {
                <div class="action-container">
                    <div class="kk-slider-buttons">
                        <button
                            class="kk-slider-button slider-button"
                            [ngClass]="{ 'button-faded': !slider.pagingLeftPossible }"
                            (click)="slider.previous()"
                        >
                            <span class="arrow kk-float-horizontally-left">
                                <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                            </span>
                            <span class="kk-visuallyhidden"> {{ 'general.action.next' | translateSafe }}</span>
                        </button>
                        <button
                            class="kk-slider-button slider-button"
                            [ngClass]="{ 'button-faded': !slider.pagingRightPossible }"
                            (click)="slider.next()"
                        >
                            <span class="arrow kk-float-horizontally-right">
                                <app-svg-icon aria-hidden="true" iconName="chevron_right"> </app-svg-icon>
                            </span>
                            <span class="kk-visuallyhidden">{{ 'general.action.previous' | translateSafe }}</span>
                        </button>
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<div class="container-fluid">
    <div class="row">
        <div class="col-12 col-lg-6 offset-lg-6" [ngClass]="{
            'col-md-12 no-packshot-content': data.useFullImage
        }">
            <div class="slider">
                <div class="slider-container">
                    <app-slider [scrollByItems]="1" #slider>
                        <ng-container *ngIf="!fetchedProducts">
                            <div
                                class="placeholder-item"
                                *ngFor="let item of [].constructor(data.productSelectorList.length)"
                            >
                                <app-loading-dots></app-loading-dots>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="fetchedProducts">
                            <div
                                class="slider-item"
                                *ngFor="let product of fetchedProducts; let i = index"
                                [appImpressionTracking]="product"
                                [index]="i + 1"
                                [impressionSource]="'Product Gallery' | impressionType"
                            >
                                <div class="slider-item-inner">
                                    <app-product-card
                                        [line]="product"
                                        [impressionSource]="'Product Gallery' | impressionType"
                                    ></app-product-card>
                                </div>
                            </div>
                        </ng-container>
                    </app-slider>
                </div>
            </div>
        </div>
    </div>
</div>
